/* eslint-disable */
import React, { useEffect, useState } from 'react';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';

// eslint-disable-next-line @typescript-eslint/no-unused-expressions
const ContractConvertData = (inputData: any) => {
 let outPutArray: any = [];

 if (!inputData || inputData.length === 0) {
  return;
 }

 if (inputData && inputData.length > 0) {
  let counter = 0;

  inputData.map((record: any) => {
   const recordNumber = counter + 1;

   let newRecord = { ...cloneDeep(record), recordNumber };

   if (newRecord.contractDate || !newRecord.contractDate) {
    newRecord.contractDate = moment(newRecord.contractDate).format(
     'DD.MM.YYYY',
    );
   }

   if (newRecord.createDate || !newRecord.createDate) {
    newRecord.createDate = newRecord.createDate
     ? moment(newRecord.createDate).format('DD.MM.YYYY')
     : '';
   }

   if (newRecord.requestDate || !newRecord.requestDate) {
    newRecord.requestDate = newRecord.requestDate
     ? moment(newRecord.requestDate).format('DD.MM.YYYY HH:MM:ss')
     : '';
   }

   if (newRecord.questionCreateDate || !newRecord.questionCreateDate) {
    newRecord.questionCreateDate = newRecord.questionCreateDate
     ? moment(newRecord.questionCreateDate).format('DD.MM.YYYY')
     : '';
   }

   if (newRecord.responseDate || !newRecord.responseDate) {
    newRecord.responseDate = newRecord.responseDate
     ? moment(newRecord.responseDate).format('DD.MM.YYYY')
     : '';
   }

   if (newRecord.responseCreateDate || !newRecord.responseCreateDate) {
    newRecord.responseCreateDate = newRecord.responseCreateDate
     ? moment(newRecord.responseCreateDate).format('DD.MM.YYYY')
     : '';
   }

   if (
    newRecord.responseInPreparationDate ||
    !newRecord.responseInPreparationDate
   ) {
    newRecord.responseInPreparationDate = newRecord.responseInPreparationDate
     ? moment(newRecord.responseInPreparationDate).format('DD.MM.YYYY')
     : '';
   }

   if (
    newRecord.responseRegistrationDate ||
    !newRecord.responseRegistrationDate
   ) {
    newRecord.responseRegistrationDate = newRecord.responseRegistrationDate
     ? moment(newRecord.responseRegistrationDate).format('DD.MM.YYYY')
     : '';
   }

   if (newRecord.responseInProcessDate || !newRecord.responseInProcessDate) {
    newRecord.responseInProcessDate = newRecord.responseInProcessDate
     ? moment(newRecord.responseInProcessDate).format('DD.MM.YYYY')
     : '';
   }

   if (newRecord.responseClosedDate || !newRecord.responseClosedDate) {
    newRecord.responseClosedDate = newRecord.responseClosedDate
     ? moment(newRecord.responseClosedDate).format('DD.MM.YYYY')
     : '';
   }

   if (newRecord.documetDate || !newRecord.documetDate) {
    newRecord.documetDate = newRecord.documetDate
     ? moment(newRecord.documetDate).format('DD.MM.YYYY')
     : '';
   }

   if (newRecord.autoContinuation || !newRecord.autoContinuation) {
    newRecord.autoContinuation = newRecord.autoContinuation ? 'Да' : 'Нет';
   }

   if (newRecord.question || !newRecord.question) {
    newRecord.question = 'Вопрос';
   }

   outPutArray.push(newRecord);
   counter++;
  });

  return outPutArray;
 }
};

export { ContractConvertData };
